import {getTime, parseISO} from "date-fns";

export const toMiliseconds = (date:string)=>{
    return getTime(parseISO(date))
}